var map = {
	"./aduan/_index.js": "QW5m",
	"./config/_index.js": "G0oB",
	"./dashboard/_index.js": "0MYX"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "wGqA";


//////////////////
// WEBPACK FOOTER
// ./src/modules _index\.js$
// module id = wGqA
// module chunks = 15